/**
 * Normalize a static asset import to a URL string.
 *
 * Vite admin builds resolve `*.png` (etc.) to plain strings. With a root
 * `tsconfig.json`, Next injects `next/image-types/global` via `next-env.d.ts`,
 * which types the same imports as `StaticImageData`. This helper keeps
 * `@ts-check` `<img src>` call sites valid for both (SCRUM-1059).
 */
export function assetUrl(asset: string | { src: string }): string {
  return typeof asset === "string" ? asset : asset.src;
}
